<div
  style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
  "
>
  <div class="Register">
    <p-dialog
      [(visible)]="displaypopup"
      [draggable]="false"
      [modal]="true"
      positionType="absolute"
      [closable]="false"
      [maximizable]="false"
      [style]="{ width: '50vw' }"
    >
      <p-header>
        <!--{{popupheader}}-->
        <h2
          class="mb-0"
          style="font-weight: unset !important; font-size: larger !important"
        >
          License Registration
        </h2>
      </p-header>

      <div class="grid">
        <form [formGroup]="form" (ngSubmit)="onSubmitForm()">
          <div class="grid">
            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="lName"
                  type="text"
                  pInputText
                  formControlName="lName"
                />
                <label for="lName"> *Last Name</label>
              </span>
            </div>

            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="fName"
                  type="text"
                  pInputText
                  formControlName="fName"
                />
                <label for="fName"> *First Name</label>
              </span>
            </div>

            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="address"
                  type="text"
                  pInputText
                  formControlName="address"
                />
                <label for="address"> *Address</label>
              </span>
            </div>
            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="emailAddress"
                  type="text"
                  pInputText
                  formControlName="emailAddress"
                />
                <label for="emailAddress"> *Email</label>
              </span>
            </div>

            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="city"
                  type="text"
                  pInputText
                  formControlName="city"
                />
                <label for="city"> City</label>
              </span>
            </div>
            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="state"
                  type="text"
                  pInputText
                  formControlName="state"
                />
                <label for="state"> State</label>
              </span>
            </div>
            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="country"
                  type="text"
                  pInputText
                  formControlName="country"
                />
                <label for="state"> Country</label>
              </span>
            </div>

            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="zipcode"
                  type="text"
                  pInputText
                  formControlName="zipCode"
                />
                <label for="zipcode"> Zip Code</label>
              </span>
            </div>
            <div class="field p-fluid col-12 md:col-4">
              <span class="p-float-label">
                <input
                  id="phone"
                  type="text"
                  pInputText
                  formControlName="phone"
                />
                <label for="phone"> *Phone</label>
              </span>
            </div>

            <div class="md:col-2 align-content-center">
              <label for="productKey" class="md:pt-2"> *Product Key</label>
            </div>

            <div class="field p-fluid col-12 md:col-2">
              <span class="p-float-label">
                <input
                  id="keyOne"
                  type="text"
                  pInputText
                  formControlName="keyOne"
                  (paste)="onPaste($event)"
                />
              </span>
            </div>
            <div class="field p-fluid col-12 md:col-2">
              <span class="p-float-label">
                <input
                  id="keyTwo"
                  type="text"
                  pInputText
                  formControlName="keyTwo"
                />
              </span>
            </div>
            <div class="field p-fluid col-12 md:col-2">
              <span class="p-float-label">
                <input
                  id="keyThree"
                  type="text"
                  pInputText
                  formControlName="keyThree"
                />
              </span>
            </div>
            <div class="field p-fluid col-12 md:col-2">
              <span class="p-float-label">
                <input
                  id="keyFour"
                  type="text"
                  pInputText
                  formControlName="keyFour"
                />
              </span>
            </div>
            <div class="field p-fluid col-12 md:col-2">
              <span class="p-float-label">
                <input
                  id="keyFive"
                  type="text"
                  pInputText
                  formControlName="keyFive"
                />
              </span>
            </div>
          </div>
          <div class="grid">
            <div
              class="field col-12 md:col-12"
              style="text-align: center !important"
            >
              <button
                pButton
                type="submit"
                icon="pi pi-check"
                label="Register"
                class="p-button-plain"
                [disabled]="this.form.invalid"
              ></button>

            </div>
          </div>
        </form>
      </div>
      <div style="display: flex; justify-content: center">
        <h5 class="license">
          <span class="pr-1">&#9888;</span> Application is not activated. Please
          provide your details and product key to continue.
        </h5>
      </div>
    </p-dialog>
  </div>
</div>
